import { render, staticRenderFns } from "./IntroduceVendorCard.vue?vue&type=template&id=4488a41e&"
import script from "./IntroduceVendorCard.vue?vue&type=script&lang=js&"
export * from "./IntroduceVendorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports